//  5 mins unix
export const LockLPBufferTime = 300;
